import { AxiosResponse } from 'axios';
import { MunicipalityListVM } from 'civil-status/view-models/research-municipality';
import { DateTime } from 'luxon';
import { HttpResponseList, HttpResponseListPayload } from 'shell/models/http-response';
import { ValueDomainType } from 'shell/models/value-domain-type';

export const transformerMunicipalityList = (
  response: AxiosResponse<HttpResponseList<ValueDomainType>>
): Array<MunicipalityListVM> => {
  const listResponse = (response.data?.payload || []) as unknown as Array<ValueDomainType>;
  const totalCount = ((response.data as unknown as HttpResponseListPayload<ValueDomainType>)
    ?.pageInfo?.totalCount || 0) as number;

  return listResponse.map((item) => ({
    id: item.key?.idValore || '',
    description: item.valore || '',
    idAnsc: item.idValoreAnsc || '',
    startValidityDate: item?.dataInizioValidita
      ? DateTime.fromISO(item?.dataInizioValidita)?.toFormat('dd/MM/yyyy')
      : '',
    endValidityDate: item?.dataFineValidita
      ? DateTime.fromISO(item?.dataFineValidita)?.toFormat('dd/MM/yyyy')
      : '',
    orderNumber: item?.numOrdinamento?.toString() || '',
    totalCount,
  }));
};
